<template>
  <RouterView />

  <div :class="{ 'dark': isDarkMode }">
    <slot />
  </div>
</template>

<script setup>
import { ref, onMounted, watch } from "vue";

const isDarkMode = ref(window.matchMedia("(prefers-color-scheme: dark)").matches);

import { useStore } from "vuex"
const store = useStore();

onMounted(() => {
  updateTheme();
  window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", updateTheme);

  setAuthenticatedUser()
});

const updateTheme = () => {
  isDarkMode.value = window.matchMedia("(prefers-color-scheme: dark)").matches;
  document.body.classList.toggle("dark-mode", isDarkMode.value);
};

const setAuthenticatedUser = () => {
  if (localStorage.getItem("isAuthenticated") && localStorage.getItem("userDetails")) {
    store.commit("setUserDetails", JSON.parse(localStorage.getItem("userDetails")))    
    store.commit("setIsLoggedIn", true)
  }
}
</script>
